import styled from 'styled-components';
import { rem } from '@innovyze/stylovyze';

export const StyledListItem = styled.div`
	margin-top: ${rem(12)};
	margin-bottom: ${rem(12)};
	margin-left: ${rem(24)};
`;
